/**
 * Personvern og samtykke-modal
 */

import React, { useState } from 'react';
import { Shield, X } from 'lucide-react';

export const PrivacyConsentModal = ({ onAccept, onDecline, isLoggedIn = false }) => {
  const [showFullPolicy, setShowFullPolicy] = useState(false);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-3xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="p-6 border-b border-slate-100">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-orange-100 rounded-xl flex items-center justify-center">
              <Shield className="w-5 h-5 text-orange-600" />
            </div>
            <h2 className="text-xl font-black text-slate-800">
              Personvern og samtykke
            </h2>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto flex-1">
          {!showFullPolicy ? (
            <div className="space-y-4">
              <p className="text-slate-700">
                For å bruke LØPDA samler vi inn og lagrer følgende data:
              </p>
              
              <div className="bg-slate-50 rounded-2xl p-4 space-y-2 text-sm">
                <div className="flex items-start gap-2">
                  <span className="text-orange-600 font-bold">•</span>
                  <span className="text-slate-700">
                    <strong>Google-profil:</strong> Navn, e-post, profilbilde
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-orange-600 font-bold">•</span>
                  <span className="text-slate-700">
                    <strong>Strava-data:</strong> Løpeaktiviteter (distanse, tid)
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-orange-600 font-bold">•</span>
                  <span className="text-slate-700">
                    <strong>Aktivitet i appen:</strong> Chat-meldinger, konkurranser
                  </span>
                </div>
              </div>

              <p className="text-sm text-slate-600">
                Dataene brukes kun for å gi deg tilgang til appen og vise statistikk. 
                Vi deler ikke data med tredjeparter for markedsføring.
              </p>

              <p className="text-sm text-slate-600">
                Du kan når som helst slette kontoen din og alle data via Profil-fanen.
              </p>

              <button
                onClick={() => setShowFullPolicy(true)}
                className="text-sm text-orange-600 font-bold hover:underline"
              >
                Les full personvernerklæring →
              </button>
            </div>
          ) : (
            <div className="space-y-4 text-sm text-slate-700">
              <h3 className="font-bold text-base text-slate-800">Full personvernerklæring</h3>
              
              <div>
                <h4 className="font-bold mb-1">Hvilke data samler vi inn?</h4>
                <p>Ved innlogging: Navn, e-post, profilbilde, Google bruker-ID</p>
                <p>Fra Strava: Løpeaktiviteter, distanse, tid, Strava-profil</p>
                <p>I appen: Chat-meldinger, konkurranser, valgt avatar</p>
              </div>

              <div>
                <h4 className="font-bold mb-1">Hvorfor samler vi dataene?</h4>
                <p>For identifikasjon, funksjonalitet (leaderboard, konkurranser) og sosiale funksjoner.</p>
              </div>

              <div>
                <h4 className="font-bold mb-1">Hvor lagres dataene?</h4>
                <p>I Google Firebase (EU-region) med kryptering.</p>
              </div>

              <div>
                <h4 className="font-bold mb-1">Dine rettigheter</h4>
                <p>Du har rett til innsyn, sletting, retting og dataportabilitet. Slett kontoen via Profil-fanen.</p>
              </div>

              <div>
                <h4 className="font-bold mb-1">Deling av data</h4>
                <p>Data deles kun med andre deltakere i konkurranser du er med i. Ingen markedsføring.</p>
              </div>

              <button
                onClick={() => setShowFullPolicy(false)}
                className="text-orange-600 font-bold hover:underline"
              >
                ← Tilbake til sammendrag
              </button>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="p-6 border-t border-slate-100 space-y-3">
          {!isLoggedIn && (
            <button
              onClick={onAccept}
              className="w-full py-3 bg-orange-600 text-white rounded-2xl font-bold hover:bg-orange-700 transition-colors"
            >
              Godkjenn og logg inn
            </button>
          )}
          <button
            onClick={onDecline}
            className="w-full py-3 bg-slate-100 text-slate-700 rounded-2xl font-bold hover:bg-slate-200 transition-colors"
          >
            Lukk
          </button>
        </div>
      </div>
    </div>
  );
};
